.page {
    width: 100%;
    max-width: var(--app-max-width);
    margin: 0 auto;
    margin-top: var(--mantine-spacing-xl);
    padding: var(--mantine-spacing-xl) var(--mantine-spacing-xs);
    align-items: flex-start;

    @container (min-width: $mantine-breakpoint-sm) {
        margin-top: var(--mantine-spacing-xl);
        padding: var(--mantine-spacing-xl);
    }
}

.titleBox {
    justify-content: space-between;
    flex-wrap: nowrap;
    @container (min-width: $mantine-breakpoint-sm) {
        padding-left: 0;
    }
}

.backButton {
    color: var(--mantine-color-dark-8);
    width: var(--mantine-spacing-lg);
    height: var(--mantine-spacing-lg);
    border-radius: var(--mantine-radius-xl);

    @container (min-width: $mantine-breakpoint-sm) {
        color: var(--mantine-color-dark-8);
    }
}

/* Single column on narrow viewports; 2-col grid from md up. The third
   (Developer) group auto-places into row 2's left cell; the right cell
   stays intentionally empty. */
.featureGroups {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-sm);

    @container (min-width: $mantine-breakpoint-md) {
        grid-template-columns: 1fr 1fr;
    }
}

.title {
    color: var(--mantine-color-dark-6);
    font-size: var(--mantine-font-size-lg);

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-xxl);
    }
}